<template>
    <ul class="form_list">
        <li class="title">
            예약 가능 기간
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span class="tooltip">고객이 앱을 통해 예약을 등록할 수 있습니다.</span>
            </span>
        </li>
        <li class="cont">
            <div class="w_full">
                현재 기준
                <select class="input_xs" v-model="blockDuration" :disabled="!isActive">
                    <option v-for="v in blockDurationNumbers" :key="v" :value="v">{{ v }}</option>
                </select>
                <select class="input_xs" v-model="blockType" :disabled="!isActive">
                    <option :value="'day'">일</option>
                    <option :value="'hour'">시간</option>
                </select>
                이후부터
                <select class="input_xs" v-model="createRange" :disabled="!isActive" @change="action_SelectCreateRange">
                    <option v-for="d in 90" :key="d" :value="d">+{{ d }}</option>
                </select>
                일 까지 예약 등록 가능
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        isActive: Boolean,
        sameDayBlockDuration: Number,
        sameDayBlockType: String,
        possibleCreateRange: Number
    },
    data() {
        return {
            blockDuration: undefined,
            blockType: '',
            createRange: undefined
        }
    },
    watch: {
        sameDayBlockType: {
            immediate: true,
            handler: function (newValue) {
                this.blockType = newValue
            }
        },
        possibleCreateRange: {
            immediate: true,
            handler: function (newValue) {
                this.createRange = newValue
            }
        },
        blockType: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (oldValue == undefined) {
                    this.blockDuration = this.sameDayBlockDuration
                } else {
                    this.blockDuration = Math.min(this.blockDuration, this.optionMaxValue)
                    this.updateValue('sameDayBlockType', newValue)
                }
            }
        },
        blockDuration: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (newValue == undefined || newValue == oldValue) { return }
                this.updateValue('sameDayBlockDuration', Number(newValue))
            }
        }
    },
    computed: {
        optionMaxValue: function () {
            return this.blockType == 'hour' ? 24 : 31
        },
        blockDurationNumbers: function () {
            return Array.from({ length: this.optionMaxValue + 1 }, (_, i) => i)
        }
    },
    methods: {
        action_SelectCreateRange(e) {
            this.updateValue('possibleCreateRange', Number(e.target.value))
        },
        updateValue(key, value) {
            let data = {
                key: key,
                value: value
            }
            this.$emit('updateValue', data)
        }
    }
}

</script>